import React from 'react';

const Settings: React.FC = () => {
    return (
        <div className="space-y-6">
            <h2 className="text-2xl font-bold text-gray-800">Settings</h2>
            <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100">
                <p className="text-gray-500">Global application settings will appear here.</p>
            </div>
        </div>
    );
};

export default Settings;
